<template>
  <div class="flex flex-direction" id="agenda" v-if="agendas != null">
    <Title :ch="'大会议程'" :bg-img="titleBgImg"></Title>
    <div class="agenda-collection">
      <!--      日期tab-->
      <dateTab
        :dateIndex="dateIndex"
        ref="agenda-date-tab"
        :dateList="agendas"
        @dateChange="agenda_dateChange"
      ></dateTab>
      <div class="content flex" v-if="agendas[dateIndex].subs2[typeIndex]">
        <!--      类型tab-->
        <type-tab
          ref="agenda-type-tab"
          :dateIndex="dateIndex"
          :typeList="agendas[dateIndex].subs2"
          @typeChange="agenda_typeChange"
          @themeIndexChange="themeIndexChange"
        ></type-tab>
        <!--      数据列表-->
        <data-list
          :dataListThemeIndex="themeIndex"
          :dataType="dataType"
          :dateIndex="dateIndex"
          :agendaList="agendas[dateIndex].subs2[typeIndex].list"
        ></data-list>
      </div>
    </div>
    <div class="tip">*以实际直播情况为准</div>
    <DidLink :isHave="true" @click.native="lookMore"></DidLink>
  </div>
</template>

<script>
import Title from "./common/Title";
import dayjs from "dayjs";
import Cookie from "js-cookie";
import { seminarAPI } from "@/services/modules/seminar";
import { hwAPI } from "@/services/modules/huawei";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "Agenda",
  data() {
    return {
      imgUrl: require("../assets/images/exhibition/exhibition9.jpg"),
      titleBgImg: require("../assets/images/agenda/home/title.png"),
      dataType: "主题演讲", //数据类型
      typeOrder: ["主题演讲", "论坛", "专场"], //默认的议程类型排序 用于议程排序
      agendas: null,
      dateIndex: 0,
      typeIndex: 0,
      themeIndex: 0, //主题演讲下标
    };
  },
  components: {
    Title,
    dateTab: () => import("../components/agenda/dateTab.vue"),
    typeTab: () => import("../components/agenda/typeTab.vue"),
    dataList: () => import("../components/agenda/dataList.vue"),
  },
  computed: mapState({
    nowTime: (state) => state.nowTime,
  }),
  mounted() {
    //获取议程列表
    this.getAgendaList();
    //监听重新获取列表
    this.$bus.$on("reGetList_home", (res) => {
      this.getAgendaList();
    });
  },
  methods: {
    /**
     * @description 获取议程列表
     * @returns {*}
     */
    getAgendaList() {
      let seminarId = this.$config.seminarId;
      seminarAPI
        .getSubSeminarList()
        .then((res) => {
          let list = res.content.items || [];
          list = this.filterList(list);
          let rawData_list = this.pipeAgendaList(list);
          if (this.$store.state["userInfo"]["token"].hwid) {
            //有华为id 去拿我的收藏的议程
            this.getMyAgendaList(list);
          } else {
            //未登录 不做我的收藏匹配
            this.dataSorting(rawData_list);
            // this.fun_promise();
          }
          this.$bus.$emit("ready", "agenda");
        })
        .catch((err) => {
          this.loadingShow = false;
        });
    },
    /**
     * @description 过滤议程列表
     * @param {Array} list 需要过滤的议程列表
     * @returns {*} 过滤后的议程分类数组
     */
    filterList(list, collect) {
      //筛选有会议类型的
      list = list.filter((item) => item.m_meetingTypeCn);
      list.forEach((item) => {
        item.isCollect = false;
        if (collect) {
          collect.forEach((item2) => {
            if (item.subSeminarId === item2.agendaId) {
              item.isCollect = true;
            }
          });
        }
      });
      //排序
      list.sort((a, b) => {
        const order = this.typeOrder;
        return (
          order.indexOf(a.m_meetingTypeCn[0]) -
          order.indexOf(b.m_meetingTypeCn[0])
        );
      });
      list.sort((a, b) => {
        if (b.startTime - a.startTime !== 0) {
          return a.startTime - b.startTime;
        }
        if (b.endTime - a.endTime !== 0) {
          return a.endTime - b.endTime;
        }
        return a.createTime - b.createTime;
      });
      //嘉宾排序
      list.forEach((item) => {
        if (Array.isArray(item.agendaList) && item.agendaList.length > 0) {
          item.agendaLists = item.agendaList[0].agendas;
          let agendas = item.agendaList;
          if (Array.isArray(agendas) && agendas.length > 0) {
            agendas.forEach((agenda) => {
              let guests = agenda.guests;
              if (Array.isArray(guests) && guests.length > 0) {
                guests.sort((a, b) => {
                  return b.guestsOrder - a.guestsOrder;
                });
              }
            });
          }
        }
      });
      return list;
    },
    /**
     * @description 按照日期、会议类型过滤议程列表
     * @param {Array} list 需要过滤的议程列表
     * @returns {*} 过滤后的议程分类数组
     */
    pipeAgendaList(list) {
      let json = {};
      for (let item of list) {
        let day = dayjs(item.startTime * 1000).format("MM.DD");
        item.type = item.m_meetingTypeCn && item.m_meetingTypeCn[0];
        item.isOpen = false;
        // item.isCollapse = false;
        if (!json[day]) {
          json[day] = {
            key: item.startTime,
            date: day,
            date2: dayjs(item.startTime * 1000).format("YYYY-MM-DD"),
            year: dayjs(item.startTime * 1000).format("YYYY"),
            month: dayjs(item.startTime * 1000).format("M"),
            day: dayjs(item.startTime * 1000).format("DD"),
            time: dayjs(item.startTime * 1000).format("HH:mm"),
            typeObj: {}, //类型对象
            subs: [], //分会场列表
            // subIds: [], //分会场列表ID
          };
        }
        // 不按照会议类型分类
        // json[day].subs.push(item)
        //按照会议类型分类
        let typeObj = json[day].typeObj;
        if (!typeObj[item.type]) {
          typeObj[item.type] = {
            type: item.type,
            list: [item],
          };
          json[day].subs.push(typeObj[item.type]);
        } else {
          typeObj[item.type].list.push(item);
        }
      }
      return Object.values(json);
    },
    //数据整理 （仅仅 线上报名版本）
    dataSorting(rawData_list) {
      rawData_list.forEach((item) => {
        item.subs2 = [];
      });
      let arr = this.typeOrder; //默认类型排序
      //类型排序
      for (let i = 0; i < arr.length; i++) {
        for (let j = 0; j < rawData_list.length; j++) {
          for (let k = 0; k < rawData_list[j].subs.length; k++) {
            if (arr[i] == rawData_list[j].subs[k].type) {
              rawData_list[j].subs2.push(rawData_list[j].subs[k]);
            }
          }
        }
      }
      rawData_list.sort((a, b) => {
        return a.key - b.key;
      });
      this.agendas = rawData_list;

      //若当前16号 ，定位到16
      if (moment(this.nowTime).format("YYYYMMDD") == "20220616") {
        this.$nextTick(() => {
          //setTimeout(() => {
          //   console.log(this.$refs["agenda-date-tab"]);
          //   this.$refs["agenda-date-tab"].activeDateIndex = 1;
          this.dateIndex = 1;
          this.dataType = "论坛";
          //}, 500);
        });
      }
    },
    link_agenda(idx) {
      // return false;
      //判断当前时间
      let agendaDate = this.$config.agendaDateList;
      let nowDay = dayjs(new Date()).format("YYYY-MM-DD");
      let isMeeting = false; //会中
      let dateIndex = 0; //议程下标
      agendaDate.forEach((item, index) => {
        if (item.day == nowDay) {
          dateIndex = index;
          isMeeting = true;
        }
      });
      //埋码
      window._hw("send", "action", "index_agenda_click", {
        agenda_name: idx == 0 ? "主题演讲" : idx == 1 ? "论坛" : "专场",
      });
      this.$router.push({
        path: "/agenda",
        query: {
          dateIndex, //日期默认下标
          tabIndex: idx, //tab 默认下标
          isHomeLink: true,
        },
      });
    },
    //埋码
    didClick_zlzs(option, idx) {
      if (this.$store.state.isMobile) {
        window._hw("send", "action", "index_online_exhibition_click", {
          exhibition_venue: option.name, // 内容名称
          product_tag: "", //产品标签
          industry_tag: "", //行业标签
          solution_tag: "", //解决方案标签
          hw_relation: this.$store.state.userInfo.hwRelation, //与华为关系
        });
      } else {
        if (idx === "0") {
          window._hw("send", "action", "index_ecology_exhibition_click", {});
        } else {
          window._hw("send", "action", "index_industry_exhibition_click", {});
        }
      }
    },
    lookMore() {
      window._hw("send", "action", "index_check_more_all_click", {
        module_name: "大会议程",
      });
      window._hw("send", "action", "index_agenda_click");
      this.$router.push({
        path: "/agenda",
      });
    },
    agenda_dateChange(e) {
      this.dateIndex = e;
      this.dataType = this.agendas[this.dateIndex].subs2[0].type;
      this.typeIndex = 0;
      this.$refs["agenda-type-tab"].tabIndex = 0;
    },
    agenda_typeChange(e) {
      this.typeIndex = e.idx;
      switch (e.type) {
        case "主题演讲":
          this.themeIndex = 0;
          this.dataType = "主题演讲";
          break;
        case "论坛":
          this.dataType = "论坛";
          break;
        case "专场":
          this.dataType = "专场";
          break;
      }
    },
    //主题演讲下标 变动
    themeIndexChange(idx) {
      this.themeIndex = idx;
    },
    /**
     * 受众 获取我收藏的 议程
     */
    getMyAgendaList(list) {
      // this.dataSorting(agendalist);
      // return
      hwAPI
        .getMyAgendaList({
          objectType: "agenda",
        })
        .then((collect) => {
          //console.log("获取我的收藏列表", collect);
          //议程数据 与 我的收藏 匹配
          let myAgendalist = this.filterList(list, collect.data);
          let agendalist = this.pipeAgendaList(myAgendalist);
          this.dataSorting(agendalist);
          // this.fun_promise();
        })
        .catch((err) => {
          this.dataSorting(this.pipeAgendaList(list));
        });
    },
  },
  destroyed() {
    this.$bus.$off("reGetList_home");
  },
};
</script>

<style lang="scss" scoped>
// agenda begin
#agenda {
  width: 100%;
}
// exxhibition end
@media screen and (max-width: 992px) {
  #agenda {
    width: 100%;
    padding-top: 143px;
    padding-bottom: 0;
    .agenda-collection {
      width: 100%;
      height: auto;
      margin-bottom: 16px;
      flex-direction: column;
      align-items: center;
      display: flex;
      .content {
        margin-top: 18px;
        flex-direction: column;
      }
    }
    .link-new {
      width: 100%;
      height: 30px;
      margin-top: 30px;
      font-size: 12px;
      span {
        height: 30px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        color: #b4251e;
        line-height: 30px;
        font-size: 24px;
        border-bottom: 1px solid #b4251e;
        padding-bottom: 1px;
      }
    }
    .tip {
      text-align: right;
      padding-top: 5px;
      padding-right: 30px;
    }
  }
}
@media screen and (min-width: 992px) {
  #agenda {
    width: 100%;
    padding: 60px 160px 60px 160px;
    .agenda-collection {
      margin-top: 5px; //保持和 沙箱实验室 距离标题高度一致
      width: 100%;
      height: auto;
      .content {
        height: 602px;
        margin-top: 18px;
      }
    }
    .link-new {
      width: 100%;
      height: 30px;
      margin-top: 30px;
      font-size: 12px;
      span {
        height: 30px;
        font-family: Microsoft YaHei-Light;
        font-weight: 400;
        color: #b4251e;
        line-height: 30px;
        font-size: 24px;
        border-bottom: 1px solid #b4251e;
        padding-bottom: 1px;
      }
    }
    .tip {
      text-align: right;
      padding-top: 5px;
    }
  }
}
</style>
